/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getIssueDetail = params => {
  return axios.get(`${base}/issue_${params.id}`, params)
}
export const getIssueLogs = params => {
  return axios.get(`${base}/issuelog_${params.id}`, params)
}
export const createIssue = params => {
  return axios.post(`${base}/create_issue_${params.order_id}`, params)
}
export const updateIssueUser = params => {
  return axios.post(`${base}/accept_issue_${params.id}`, params)
}
export const updateIssueOpen = params => {
  return axios.post(`${base}/redeal_issue_${params.id}`, params)
}
export const updateIssueFinish = params => {
  return axios.post(`${base}/finish_issue_${params.id}`, params)
}
export const updateIssueFinishAndOrderNotPassed = params => {
  return axios.post(`${base}/giveup_issue_${params.id}`, params)
}
export const updateIssueWait = params => {
  return axios.post(`${base}/suspend_issue_${params.id}`, params)
}
export const addIssueComment = params => {
  return axios.post(`${base}/addcomment_issue_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/issue/issue.api.js